/**
 * BUSINESS_TIME_ZONE is the calendar an engagement's dates are read against.
 *
 * Must match BusinessTimeZone in internal/people/model.go. The server derives a
 * term's status against that calendar, so a console computing "today" in the
 * viewer's zone would disagree with the answer it is displaying.
 */
export const BUSINESS_TIME_ZONE = "Asia/Seoul";

/** businessDate is the business calendar date as `YYYY-MM-DD`. */
export function businessDate(now: Date = new Date()): string {
  // en-CA formats as YYYY-MM-DD, which is the shape the API's Date scalar takes.
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: BUSINESS_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(now);
}

/**
 * A recorded instant as it reads on the business calendar —
 * `2026-10-20 12:00 Asia/Seoul`. The zone is named so nobody reads it as their own.
 */
export function formatOnBusinessCalendar(instant: string): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: BUSINESS_TIME_ZONE,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).formatToParts(new Date(instant));
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? "00";
  return `${part("year")}-${part("month")}-${part("day")} ${part("hour")}:${part("minute")} ${BUSINESS_TIME_ZONE}`;
}
